import React from 'react';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

import { Gallery, Item } from 'react-photoswipe-gallery';

const MyGallery = () => (
  <Gallery>
      <Item
      original="gallery/Bachelor Summit.png"
      thumbnail="gallery/Thumbnails/Bachelor Summit.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Bachelor Summit.png" width="33.33%" alt="The summit of Mount Bachelor in Bend Oregon." />
      )}
    </Item><Item
      original="gallery/Death Valley.png"
      thumbnail="gallery/Thumbnails/Death Valley.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Death Valley.png" width="33.33%" alt="An overlook in Death Valley National Park." />
      )}
    </Item><Item
      original="gallery/Dillan.png"
      thumbnail="gallery/Thumbnails/Dillan.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Dillan.png" width="33.33%" alt="Sunset over the top of mountains right outside Dillan, Colorado." />
      )}
    </Item><Item
      original="gallery/Fall Creek.png"
      thumbnail="gallery/Thumbnails/Fall Creek.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Fall Creek.png" width="33.33%" alt="A dog overlooking Fall Creek in Idaho." />
      )}
    </Item><Item
      original="gallery/Little Si.png"
      thumbnail="gallery/Thumbnails/Little Si.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Little Si.png" width="33.33%" alt="Dog in nature." />
      )}
    </Item><Item
      original="gallery/Milky Way.png"
      thumbnail="gallery/Thumbnails/Milky Way.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Milky Way.png" width="33.33%" alt="The Milky way outside of Bear Creek Hot Springs." />
      )}
    </Item><Item
      original="gallery/Rufus.png"
      thumbnail="gallery/Thumbnails/Rufus.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Rufus.png" width="33.33%" alt="Dog overlooking the Columbia River Valley in Rufus, Oregon." />
      )}
    </Item><Item
      original="gallery/Todd Lake.png"
      thumbnail="gallery/Thumbnails/Todd Lake.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Todd Lake.png" width="33.33%" alt="A dog overlooking Todd Lake with Broken Top in the background." />
      )}
    </Item><Item
      original="gallery/Wolf Flats.png"
      thumbnail="gallery/Thumbnails/Wolf Flats.png"
      width="1024"
      height="768"
    >
      {({ ref, open }) => (
        <img ref={ref} onClick={open} src="gallery/Thumbnails/Wolf Flats.png" width="33.33%" alt="An overlook at Wolf Flats in Idaho." />
      )}
    </Item>
  </Gallery>
)

export default MyGallery;



// WEBPACK FOOTER //
// ./src/Components/Gallery.js